export default __webpack_public_path__ + "static/media/widget-placement-child-first.9a795ab1.svg";